import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';

import { AccordionModule } from 'primeng/accordion';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { AvatarModule } from 'primeng/avatar';
import { AvatarGroupModule } from 'primeng/avatargroup';
import { BadgeModule } from 'primeng/badge';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { ButtonModule } from 'primeng/button';
import { CalendarModule } from 'primeng/calendar';
import { CardModule } from 'primeng/card';
import { CarouselModule } from 'primeng/carousel';
import { CascadeSelectModule } from 'primeng/cascadeselect';
import { ChartModule } from 'primeng/chart';
import { CheckboxModule } from 'primeng/checkbox';
import { ChipModule } from 'primeng/chip';
import { ChipsModule } from 'primeng/chips';
import { CodeHighlighterModule } from 'primeng/codehighlighter';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { ColorPickerModule } from 'primeng/colorpicker';
import { ContextMenuModule } from 'primeng/contextmenu';
import { DataViewModule } from 'primeng/dataview';
import { DialogModule } from 'primeng/dialog';
import { DialogService, DynamicDialogModule } from 'primeng/dynamicdialog';
import { DividerModule } from 'primeng/divider';
import { DropdownModule } from 'primeng/dropdown';
import { FieldsetModule } from 'primeng/fieldset';
import { FileUploadModule } from 'primeng/fileupload';
import { FullCalendarModule } from 'primeng/fullcalendar';
import { GalleriaModule } from 'primeng/galleria';
import { InplaceModule } from 'primeng/inplace';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputMaskModule } from 'primeng/inputmask';
import { InputSwitchModule } from 'primeng/inputswitch';
import { InputTextModule } from 'primeng/inputtext';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { KnobModule } from 'primeng/knob';
import { LightboxModule } from 'primeng/lightbox';
import { ListboxModule } from 'primeng/listbox';
import { MegaMenuModule } from 'primeng/megamenu';
import { MenuModule } from 'primeng/menu';
import { MenubarModule } from 'primeng/menubar';
import { MessagesModule } from 'primeng/messages';
import { MessageModule } from 'primeng/message';
import { MultiSelectModule } from 'primeng/multiselect';
import { OrderListModule } from 'primeng/orderlist';
import { OrganizationChartModule } from 'primeng/organizationchart';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { PaginatorModule } from 'primeng/paginator';
import { PanelModule } from 'primeng/panel';
import { PanelMenuModule } from 'primeng/panelmenu';
import { PasswordModule } from 'primeng/password';
import { PickListModule } from 'primeng/picklist';
import { ProgressBarModule } from 'primeng/progressbar';
import { RadioButtonModule } from 'primeng/radiobutton';
import { RatingModule } from 'primeng/rating';
import { RippleModule } from 'primeng/ripple';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { ScrollTopModule } from 'primeng/scrolltop';
import { SelectButtonModule } from 'primeng/selectbutton';
import { SidebarModule } from 'primeng/sidebar';
import { SkeletonModule } from 'primeng/skeleton';
import { SlideMenuModule } from 'primeng/slidemenu';
import { SliderModule } from 'primeng/slider';
import { SplitButtonModule } from 'primeng/splitbutton';
import { SplitterModule } from 'primeng/splitter';
import { StepsModule } from 'primeng/steps';
import { TabMenuModule } from 'primeng/tabmenu';
import { TableModule } from 'primeng/table';
import { TabViewModule } from 'primeng/tabview';
import { TagModule } from 'primeng/tag';
import { TerminalModule } from 'primeng/terminal';
import { TieredMenuModule } from 'primeng/tieredmenu';
import { TimelineModule } from 'primeng/timeline';
import { ToastModule } from 'primeng/toast';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { ToolbarModule } from 'primeng/toolbar';
import { TooltipModule } from 'primeng/tooltip';
import { TreeModule } from 'primeng/tree';
import { TreeTableModule } from 'primeng/treetable';
import { VirtualScrollerModule } from 'primeng/virtualscroller';
import { ConfirmationService, MessageService } from 'primeng/api';


import { LoggingService } from '@pit/core';
import { PinItCoreSignalRModule } from '@pit/core-signalr';
import { FormsModule } from '@angular/forms';
import { PinItTrackFrontendModelModule } from '@pit/frontend-model';
import { DtoDepotStoreFactory } from './module.store/dto.depot/dto.depot.store.factory';
import { DtoDeviceStoreFactory } from './module.store/dto.device/dto.device.store.factory';
import { DtoUserStoreFactory } from './module.store/dto.user/dto.user.store.factory';
import { DtoUserRoleStoreFactory } from './module.store/dto.user.role/dto.user.role.store.factory';
import { DtoDepotEffects } from './module.store/dto.depot/dto.depot.effects';
import { DtoDeviceEffects } from './module.store/dto.device/dto.device.effects';
import { DtoUserEffects } from './module.store/dto.user/dto.user.effects';
import { DtoUserRoleEffects } from './module.store/dto.user.role/dto.user.role.effects';
import { DtoShipmentStoreFactory } from './module.store/dto.shipment/dto.shipment.store.factory';
import { DtoShipmentEffects } from './module.store/dto.shipment/dto.shipment.effects';
import { pinItTrackFrontendCoreServicesProviders } from './module.core/providers/pin.it.track.frontend.core.services.providers';
import { DtoShipmentProcessStoreFactory } from './module.store/dto.shipment.process/dto.shipment.process.store.factory';
import { DtoShipmentProcessEffects } from './module.store/dto.shipment.process/dto.shipment.process.effects';
import { DtoShipmentReturnCodeStoreFactory } from './module.store/dto.shipment.return.code/dto.shipment.return.code.store.factory';
import { DtoShipmentReturnCodeEffects } from './module.store/dto.shipment.return.code/dto.shipment.return.code.effects';
import { DtoResourceStoreFactory } from './module.store/dto.resource/dto.resource.store.factory';
import { DtoResourceEffects } from './module.store/dto.resource/dto.resource.effects';
import { DtoResourceTypeStoreFactory } from './module.store/dto.resource.type/dto.resource.type.store.factory';
import { DtoResourceTypeEffects } from './module.store/dto.resource.type/dto.resource.type.effects';
import { DtoResourceFaultStoreFactory } from './module.store/dto.resource.fault/dto.resource.fault.store.factory';
import { DtoResourceFaultEffects } from './module.store/dto.resource.fault/dto.resource.fault.effects';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,

        AccordionModule,
        AutoCompleteModule,
        AvatarModule,
        AvatarGroupModule,
        BadgeModule,
        BreadcrumbModule,
        ButtonModule,
        CalendarModule,
        CardModule,
        CarouselModule,
        CascadeSelectModule,
        ChartModule,
        CheckboxModule,
        ChipModule,
        ChipsModule,
        CodeHighlighterModule,
        ConfirmDialogModule,
        ConfirmPopupModule,
        ColorPickerModule,
        ContextMenuModule,
        DataViewModule,
        DialogModule,
        DividerModule,
        DropdownModule,
        DynamicDialogModule,
        FieldsetModule,
        FileUploadModule,
        FullCalendarModule,
        GalleriaModule,
        InplaceModule,
        InputNumberModule,
        InputMaskModule,
        InputSwitchModule,
        InputTextModule,
        InputTextareaModule,
        KnobModule,
        LightboxModule,
        ListboxModule,
        MegaMenuModule,
        MenuModule,
        MenubarModule,
        MessageModule,
        MessagesModule,
        MultiSelectModule,
        OrderListModule,
        OrganizationChartModule,
        OverlayPanelModule,
        PaginatorModule,
        PanelModule,
        PanelMenuModule,
        PasswordModule,
        PickListModule,
        ProgressBarModule,
        RadioButtonModule,
        RatingModule,
        RippleModule,
        ScrollPanelModule,
        ScrollTopModule,
        SelectButtonModule,
        SidebarModule,
        SkeletonModule,
        SlideMenuModule,
        SliderModule,
        SplitButtonModule,
        SplitterModule,
        StepsModule,
        TableModule,
        TabMenuModule,
        TabViewModule,
        TagModule,
        TerminalModule,
        TimelineModule,
        TieredMenuModule,
        ToastModule,
        ToggleButtonModule,
        ToolbarModule,
        TooltipModule,
        TreeModule,
        TreeTableModule,
        VirtualScrollerModule,

        StoreModule.forRoot({}, {
            runtimeChecks: {
                strictStateImmutability: false,
                strictActionImmutability: false
            }
        }),
        EffectsModule.forRoot([]),

        PinItCoreSignalRModule,
        PinItTrackFrontendModelModule,

        StoreModule.forFeature('DtoDepot', DtoDepotStoreFactory.instance.getEntityReducer()),
        StoreModule.forFeature('DtoDevice', DtoDeviceStoreFactory.instance.getEntityReducer()),
        StoreModule.forFeature('DtoResource', DtoResourceStoreFactory.instance.getEntityReducer()),
        StoreModule.forFeature('DtoResourceType', DtoResourceTypeStoreFactory.instance.getEntityReducer()),
        StoreModule.forFeature('DtoResourceFault', DtoResourceFaultStoreFactory.instance.getEntityReducer()),
        StoreModule.forFeature('DtoShipment', DtoShipmentStoreFactory.instance.getEntityReducer()),
        StoreModule.forFeature('DtoShipmentProcess', DtoShipmentProcessStoreFactory.instance.getEntityReducer()),
        StoreModule.forFeature('DtoShipmentReturnCode', DtoShipmentReturnCodeStoreFactory.instance.getEntityReducer()),
        StoreModule.forFeature('DtoUser', DtoUserStoreFactory.instance.getEntityReducer()),
        StoreModule.forFeature('DtoUserRole', DtoUserRoleStoreFactory.instance.getEntityReducer()),
        EffectsModule.forFeature([DtoDepotEffects, DtoDeviceEffects, DtoResourceEffects, DtoResourceTypeEffects, DtoResourceFaultEffects, DtoShipmentEffects, DtoShipmentProcessEffects, DtoShipmentReturnCodeEffects, DtoUserEffects, DtoUserRoleEffects])
    ],
    providers: [
        ...pinItTrackFrontendCoreServicesProviders,
        ConfirmationService, DialogService, MessageService
    ]
})
export class PinItTrackFrontendSharedInitModule {

    constructor(loggingService: LoggingService) {
        loggingService.debug('PinItTrackFrontendSharedInitModule --> constructor()');
    }

    public static forRoot(): ModuleWithProviders<PinItTrackFrontendSharedInitModule> {
        return {
            ngModule: PinItTrackFrontendSharedInitModule,
            providers: [
                ...pinItTrackFrontendCoreServicesProviders,
                ConfirmationService, DialogService, MessageService
            ]
        };
    }

}
